// frontend/src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

function ProtectedRoute({ children }) {
  const { token, loading } = useContext(AuthContext);
  const location = useLocation();

  // Если данные еще загружаются (проверка токена и пользователя), показываем спиннер
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Если пользователь не аутентифицирован, перенаправляем на страницу входа
  // и сохраняем текущий путь в состоянии location.state.from
  if (!token) {
    // Проверяем, откуда пришел пользователь, чтобы не перенаправлять с /login на /login
    if (location.pathname !== '/login') {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    // Если уже на /login, просто рендерим children (страницу входа)
    return children;
  }

  // Если пользователь аутентифицирован, отображаем защищенный компонент
  return children;
}

export default ProtectedRoute;
